import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useContentBlockStore } from '../stores/content-block-store'

import type { NewContentBlock } from '../stores/content-block-store'
import type { ContentBlocksAndAdSlotMarkers } from '../types/content-block-types'

export function useContentBlock <T extends ContentBlocksAndAdSlotMarkers['paragraphType']> (id: string, type: T) {
  const store = useContentBlockStore()
  const { contentBlockList } = storeToRefs(store)

  // Return the computed property that will reactively update when the content block list changes
  return computed(() => {
    const block = contentBlockList.value.find(block => block.id === id)
    if (!block) {
      throw new Error(`Content block with id ${id} and type ${type} not found`)
    }
    // Return the block with the correct type narrowed to the paragraphType
    return block as NewContentBlock<Extract<ContentBlocksAndAdSlotMarkers, { paragraphType: T }>>
  })
}
